import { ReportField } from '../models/api/reports/report';

export class ReportFieldUtils {
  static filterSelectedFields(
    allFields: ReportField[],
    selectedFields: ReportField[],
  ): ReportField[] {
    return allFields.filter(
      (field) =>
        !selectedFields.some(
          (sf) =>
            sf.tableAlias === field.tableAlias &&
            sf.columnName === field.columnName,
        ),
    );
  }

  static mapToFieldIdentifier(field: ReportField): string {
    return `${field.tableAlias}.${field.columnName}`;
  }

  static sortByUserOrder(fields: ReportField[]): ReportField[] {
    return [...fields].sort((a, b) => {
      const orderA = a.displayOrder ?? 0;
      const orderB = b.displayOrder ?? 0;
      return orderA - orderB;
    });
  }

  static isSameField(field1: ReportField, field2: ReportField): boolean {
    return (
      field1.tableAlias === field2.tableAlias &&
      field1.columnName === field2.columnName
    );
  }

  static addUserInputOrder(fields: ReportField[]): ReportField[] {
    return fields.map((field, index) => ({
      ...field,
      displayOrder: index + 1,
    }));
  }

  static toFieldIdentifiers(fields: ReportField[]): string[] {
    return fields.map((field) => ReportFieldUtils.mapToFieldIdentifier(field));
  }
}
